import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SubmarketRow from './SubmarketRow';
import { submarketsType, sortingParamType } from '../../types';
import './_styles_/SubmarketsList.css';
import SortControl from '../SortControl';

SubmarketsList.propTypes = {
    submarkets: submarketsType.isRequired,
    onSort: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function SubmarketsList(props) {
    const {
        submarkets,
        onSort,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="submarkets-list">
            <div className="rich-list-row rich-list-header submarkets-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="submarket-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('submarkets.list-header.name')}
                    </SortControl>
                </div>
                <div className="submarket-header--values--code">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="code">
                        {t('submarkets.list-header.code')}
                    </SortControl>
                </div>
                <div className="submarket-header--values--active">
                    <SortControl sortingKey="active" sortingParam={sortingParam} onChange={onSort}>
                        {t('submarkets.list-header.active')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                submarkets.length
                    ? submarkets.map((submarket) => <SubmarketRow submarket={submarket} key={submarket.id} />)
                    : (<div className="submarkets-no-items">{t('submarkets.no-items')}</div>)
            }
        </div>
    );
}

export default SubmarketsList;
